import { observer } from 'mobx-react-lite'
import { Select } from 'blaze-ui/Select/Select'
import { Item } from '@react-stately/collections'
import { TextInputField } from 'components/Form/TextInputField'
import { GoHighLevelAuthor } from 'api/clients/BlogMetadataRecordsClient'
import Styles from '../../../BlogMetadata.module.scss'

type GoHighLevelAuthorSelectProps = {
  authors: GoHighLevelAuthor[]
  selectedAuthorId?: string
  onAuthorSelect: (authorId: string) => void
  placeholder?: string
  disabled?: boolean
}

export const GoHighLevelAuthorSelect = observer(
  ({
    authors,
    selectedAuthorId,
    onAuthorSelect,
    placeholder = 'Select an author',
    disabled = false,
  }: GoHighLevelAuthorSelectProps) => {
    const isEmpty = authors.length === 0
    const isSingleAuthor = authors.length === 1

    // Auto-select single author
    if (isSingleAuthor) {
      const singleAuthor = authors[0]
      if (selectedAuthorId !== singleAuthor.id) {
        onAuthorSelect(singleAuthor.id)
      }

      return (
        <TextInputField
          wrapperClassName={Styles.inputField}
          label="Author"
          value={singleAuthor.name}
          onChange={() => {}}
          size="lg"
          labelClassName={Styles.textFieldLabel}
          isReadOnly
          isDisabled={disabled}
        />
      )
    }

    return (
      <Select
        placeholder={isEmpty ? 'No authors available' : placeholder}
        selectedKey={selectedAuthorId}
        onSelectionChange={(key) => onAuthorSelect(key as string)}
        isDisabled={isEmpty || disabled}
        useButtonWidth={true}
        useFullWidth={true}
        variant="secondary"
        size="lg"
      >
        {authors.map((author) => (
          <Item key={author.id} textValue={author.name}>
            {author.name}
          </Item>
        ))}
      </Select>
    )
  },
)
